import React, {Component} from 'react';
import BottomLinks from "./common/BottomLinks";
import BreadCrumb from "./common/BreadCrumb";
import {connect} from 'react-redux';
import * as Constants from './common/Constants';
import * as Tagging from "./tagging/LeadFormTagging";
import DealsService from '../services/DealsService';

class SuccessPage extends Component {

    constructor(props) {
        super(props);
        this.getDeviceDeals = this.getDeviceDeals.bind(this);
    }

    componentDidMount() {        
        if(this.props.match.params.type === 'email') {
            Tagging.emailLeadSuccessEvent(this.props.leads.productName);
        } else if(this.props.match.params.type === 'fixed'){
            Tagging.leadSuccessEvent(this.props.match.params.type,this.props.match.params.requestType,this.props.match.params.reference,
                this.props.match.params.model,this.props.match.params.price, this.props.leads.productName);
        } else {
            this.getDeviceDeals(this.props.match.params.deviceId, this.props.match.params.dealId);
        }
    }

    getDeviceDeals = (deviceId, dealId) => {
        DealsService.getDealsForDevice(deviceId)
            .then((res) => {
                const deals = res.data.result.deals;
                deals.map((e, i) => {
                        if (parseInt(dealId) === parseInt(e.dealId)) {
                            let dealDetail = {};

                            dealDetail.totalMonthlySubscription = e.totalMonthlySubscription;
                            dealDetail.dealShortDescription = e.dealShortDescription;
                            dealDetail.packageDescription = e.packageDetail.packageDescription;
                            dealDetail.dealId = e.dealId;

                            Tagging.leadSuccessEvent(this.props.match.params.type,this.props.match.params.requestType,this.props.match.params.reference,
                                this.props.match.params.model,this.props.match.params.price, this.props.leads.productName, dealDetail);
                        }
                    })
            }).catch((error) => {
            console.log(error);
        })
    }

    render() {
        return (
            <React.Fragment>
                <div className="main-content-wrapper">
                <BreadCrumb currentPage={'Call me back'}/>
                    <div className="parent-main-wrapper leads-form">
                        <div className="popUP-section">
                            <div className="success">
                            <span className="svgOuter"><svg focusable="false" aria-hidden="true"
                                                            className="icon top-svg"> <use
                                xlink="http://www.w3.org/1999/xlink" href="#icon-tick" /></svg></span>
                                <label automationid="SuccessPage_Label_Title_1" className="title">We'll be in touch shortly!</label>
                                <span automationid="SuccessPage_Label_SubTitle_1" className="sub-title">{this.props.match.params.reference && `Your reference number is: ${this.props.match.params.reference}`}</span>
                                <span automationid="SuccessPage_Label_SubTitle_2" className="sub-title">A call centre agent will give you a call within the next 24 hours</span>
                                <label automationid="SuccessPage_Link_GoToHome_1" className="btn btn-red" onClick={() => Constants.redirectToHome()}>Go to
                                    homepage</label>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomLinks/>
            </React.Fragment>
        );
    }

}


const mapStateToProps = state => {
    return {
        leads: state.leads
    }
}

export default connect(mapStateToProps, null)(SuccessPage);
